import helpers from './helpers';
import api from './api';

import AddressFormatter from '@shopify/address';
const addressFormatter = new AddressFormatter('en');


import GET_PRODUCTS_QUERY from './graphql/2024_01/products/get.graphql';
import PRODUCT_FRAGMENT from './graphql/2024_01/products/product_fragment.graphql';

// Filter ID patterns
export const FILTER_ID_PATTERNS = {
  // Product filters
  PRODUCT_CATEGORY: /^filter\.t\.category\.(.+)$/,
  PRODUCT_TAG: /^filter\.p\.tag\.(.+)$/,
  PRODUCT_TYPE: /^filter\.p\.product_type\.(.+)$/,
  PRODUCT_VENDOR: /^filter\.p\.vendor\.(.+)$/,
  PRODUCT_METAFIELD: /^filter\.p\.m\.(.+)$/,

  VARIANT_AVAILABILITY: /^filter\.v\.availability\.(.+)$/,
  VARIANT_OPTION: /^filter\.v\.option\.(.+)$/,
  VARIANT_PRICE: /^filter\.v\.price\.(.+)$/,
  VARIANT_TAXONOMY: /^filter\.v\.t\.(.+)$/,
  VARIANT_METAFIELD: /^filter\.v\.m\.(.+)$/
};

export default {
  generateProductFilterUrlParam(id, value) {
    // Product category filter
    const productCategoryMatch = id?.match(FILTER_ID_PATTERNS?.PRODUCT_CATEGORY);
    if (productCategoryMatch) {
      return `filter.filter.t.category=${encodeURIComponent(productCategoryMatch[1])}`;
    }

    // Product tag filter
    const productTagMatch = id?.match(FILTER_ID_PATTERNS?.PRODUCT_TAG);
    if (productTagMatch) {
      return `filter.filter.p.tag=${encodeURIComponent(value)}`;
    }

    // Product type filter
    const productTypeMatch = id?.match(FILTER_ID_PATTERNS?.PRODUCT_TYPE);
    if (productTypeMatch) {
      return `filter.filter.p.product_type=${encodeURIComponent(value)}`;
    }

    // Product vendor filter
    const productVendorMatch = id?.match(FILTER_ID_PATTERNS.PRODUCT_VENDOR);
    if (productVendorMatch) {
      return `filter.filter.p.vendor=${encodeURIComponent(value)}`;
    }

    // Product metafield filter
    const productMetafieldMatch = id?.match(FILTER_ID_PATTERNS.PRODUCT_METAFIELD);
    if (productMetafieldMatch) {
      const namespaceKey = productMetafieldMatch[1].replace(`.${value.toLowerCase()}`, '');

      return `filter.filter.p.m.${namespaceKey}=${encodeURIComponent(value)}`;
    }

    // Variant availability filter
    const variantAvailabilityMatch = id?.match(FILTER_ID_PATTERNS.VARIANT_AVAILABILITY);
    if (variantAvailabilityMatch) {
      return `filter.filter.v.availability=${variantAvailabilityMatch[1] === '1'}`;
    }

    // Variant option filter
    const variantOptionMatch = id?.match(FILTER_ID_PATTERNS.VARIANT_OPTION);
    if (variantOptionMatch) {
      return `filter.filter.v.option=${encodeURIComponent(value)}`;
    }

    // Variant price filter

    // Variant taxonomy filter
    const variantTaxonomyMatch = id?.match(FILTER_ID_PATTERNS.VARIANT_TAXONOMY);
    if (variantTaxonomyMatch) {
      const namespaceKeyArray = variantTaxonomyMatch[1].split('.');
      const taxonomy = namespaceKeyArray.pop();
      const namespaceKey = namespaceKeyArray.join('.');
      const taxonomyArray = taxonomy.split('-');
      const taxonomyId = taxonomyArray.pop();

      return `filter.filter.v.t.${namespaceKey}=${encodeURIComponent(`gid://shopify/TaxonomyValue/${taxonomyId}`)}`;
    }

    // Variant metafield filter
    const variantMetafieldMatch = id?.match(FILTER_ID_PATTERNS.VARIANT_METAFIELD);
    if (variantMetafieldMatch) {
      const namespaceKey = variantMetafieldMatch[1].replace(`.${value.toLowerCase()}`, '');

      return `filter.filter.v.m.${namespaceKey}=${encodeURIComponent(value)}`;
    }
  },

  generateProductFilterFromParam(param, value) {
    // Product category filter
    const productCategoryMatch = param.match(FILTER_ID_PATTERNS.PRODUCT_CATEGORY);
    if (productCategoryMatch) {
      return {
        category: {
          id: value
        }
      };
    }

    // Product tag filter
    const productTagMatch = param.match(FILTER_ID_PATTERNS.PRODUCT_TAG);
    if (productTagMatch) {
      return {
        tag: value
      };
    }

    // Product type filter
    const productTypeMatch = param.match(FILTER_ID_PATTERNS.PRODUCT_TYPE);
    if (productTypeMatch) {
      return {
        productType: value
      };
    }

    // Product vendor filter
    const productVendorMatch = param.match(FILTER_ID_PATTERNS.PRODUCT_VENDOR);
    if (productVendorMatch) {
      return {
        productVendor: value
      };
    }

    // Product metafield filter
    const productMetafieldMatch = param.match(FILTER_ID_PATTERNS.PRODUCT_METAFIELD);
    if (productMetafieldMatch) {
      const parts = productMetafieldMatch[1].split('.');

      return {
        productMetafield: {
          namespace: parts[0],
          key: parts[1],
          value: value
        }
      };
    }

    // Variant availability filter
    const variantAvailabilityMatch = param.match(FILTER_ID_PATTERNS.VARIANT_AVAILABILITY);
    if (variantAvailabilityMatch) {
      return {
        available: value
      };
    }

    // Variant option filter
    const variantOptionMatch = param.match(FILTER_ID_PATTERNS.VARIANT_OPTION);
    if (variantOptionMatch) {
      return {
        variantOption: {
          name: label,
          value: value
        }
      };
    }

    // Variant price filter

    // Variant taxonomy filter
    const variantTaxonomyMatch = param.match(FILTER_ID_PATTERNS.VARIANT_TAXONOMY);
    if (variantTaxonomyMatch) {
      const parts = variantTaxonomyMatch[1].split('.');
      return {
        taxonomyMetafield: {
          namespace: parts[0],
          key: parts[1],
          value: value
        }
      };
    }

    // Variant metafield filter
    const variantMetafieldMatch = param.match(FILTER_ID_PATTERNS.VARIANT_METAFIELD);
    if (variantMetafieldMatch) {
      const parts = variantMetafieldMatch[1].split('.');
      return {
        variantMetafield: {
          namespace: parts[0],
          key: parts[1],
          value: value
        }
      };
    }
  },

  getRelatedProductsQuery(tags) {
    const tagQuery = tags.map((tag) => `tag:'${tag}'`).join(' OR ');
    return `
    query getRelatedProducts {
      products(first: 10, query: "(${tagQuery})") {
        edges {
          node {
            id
            title
            handle
            images(first: 10) {
              edges {
                node {
                  altText
                  src
                }
              }
            }
          }
        }
      }
    }
  `;
  },
  // Helper function to generate the GraphQL query
  getRelatedProductsByHandleQuery(handles) {
    const handlesString = handles.map((handle) => `'${handle}'`).join(' OR ');
    return `
        {
            products(first: 20, query: "(${handlesString})") {
                edges {
                    node {
                        id
                        title
                        handle
                        tags

                        priceRange {
                            maxVariantPrice {
                              amount
                            }
                            minVariantPrice {
                              amount
                            }
                        }
                        variants(first: 100) {
                            edges {
                              node {
                                id
                                availableForSale
                                selectedOptions {
                                  value
                                }
                                compareAtPrice {
                                  amount
                                }
                                image {
                                  altText
                                  url
                                }
                              }
                            }
                          }
                        images(first: 10) {
                            edges {
                                node {
                                    src
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
  },

  // Helper function to generate the GraphQL query for a single product
  getSingleProductByHandleQuery(handle) {
    return `
        {
            product(handle: "${handle}") {
                id
                title
                handle
                tags
                vendor
                priceRange {
                    maxVariantPrice {
                      amount
                    }
                    minVariantPrice {
                      amount
                    }
                }
                variants(first: 100) {
                  edges {
                    node {
                      id
                      availableForSale
                      selectedOptions {
                        value
                      }
                      compareAtPrice {
                        amount
                      }
                      image {
                        altText
                        url
                      }
                    }
                  }
                }
                short_description: metafield(namespace: "custom", key: "short_description") {
                  value
                }
                images(first: 10) {
                    edges {
                        node {
                            src
                            url
                        }
                    }
                }
            }
        }
    `;
  },

  async getMetafieldsForProduct(ids, metafieldIdentifiers = null) {
    // Ensure IDs are in proper GraphQL format
    const formattedIds = ids.map(id =>
      id.toString().startsWith('gid://shopify/Product/')
        ? id
        : `gid://shopify/Product/${id}`
    );

    // Use custom metafield identifiers or default ones
    const identifiers = metafieldIdentifiers || [
      { namespace: "custom", key: "bottle_siblings" },
      { namespace: "custom", key: "bottle_colour" },
      { namespace: "custom", key: "bottle_colour_name" }
    ];

    const query = `
        query getProductMetafields($ids: [ID!]!, $identifiers: [HasMetafieldsIdentifier!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              handle
              metafields(identifiers: $identifiers) {
                namespace
                key
                value
                type
                description
              }
            }
          }
        }
      `;

    // Construct headers for the Storefront API
    const headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': `${api.getStorefrontToken()}`
    };

    try {
      // Send the request
      const endpoint = api.getStorefrontGraphqlBaseUrl();
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          query: query,
          variables: {
            ids: formattedIds,
            identifiers: identifiers
          }
        })
      });

      const jsonResponse = await response.json();

      // Check for GraphQL errors
      if (jsonResponse.errors) {
        console.error('GraphQL errors:', jsonResponse.errors);
        throw new Error('GraphQL query failed');
      }

      // Extract products
      const products = jsonResponse.data?.nodes || [];

      // Transform the products as needed
      const transformedProducts = products.map((product) => this.transformGraphqlProduct(product));

      return transformedProducts;
    } catch (error) {
      console.error('Error fetching metafields:', error);
      throw error;
    }
  },
  async authenticatedFetch(fetchDetails) {
    fetchDetails.url = `${helpers.getDomain()}/admin/api/2024-01/graphql.json`;
    fetchDetails.shop_url = `${helpers.getDomain(false, true)}/admin/api/2024-01/graphql.json`;
    fetchDetails.key = 'SHOPIFY_API_AUTHENTICATED_KEY';
    // fetchDetails.hash = sig;

    const response = await fetch(`${helpers.getDomain()}/apps/arctheme/fetch`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(fetchDetails)
    });

    if (!response.ok) {
      console.error(`Error calling authenticated api: ${response.statusText}`);
    }
    return await response.json();
  },
  async unauthenticatedFetch(query, variables = null) {
    // Construct the URL based on the 'storefront' flag
    const apiPath = storefront ? 'api' : 'admin/api';
    const url = `${helpers.getDomain()}/${apiPath}/2025-01/graphql.json`;

    // Construct headers conditionally based on the 'storefront' flag
    let headers = {
      'Content-Type': 'application/graphql'
    };

    if (storefront) {
      headers['X-Shopify-Storefront-Access-Token'] = `${api.getStorefrontToken()}`; // This key to be stored elsewhere
    } else {
      headers['X-Shopify-Access-Token'] = `${api.getPublicAccessToken()}`; // This key to be stored elsewhere (Can only be private app key, cannot be the public/custom app key)
    }

    // Perform the GraphQL request
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: query
    });

    return await response.json();
  },

  async getStockForProducts(productData) {
    const data = {
      query: GET_PRODUCTS_QUERY.loc.source.body,
      variables: {
        ids: productData.reduce((filtered, id) => {
          filtered.push('gid://shopify/Product/' + id);
          return filtered;
        }, [])
      }
    };

    let headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
    };

    const endpoint = api.getStorefrontGraphqlBaseUrl();
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    });
    
    const jsonResponse = await response.json();
    // const products = jsonResponse.data?.nodes.filter((node) => node);
    const products = jsonResponse.data?.nodes
      .filter((node) => node)
      .map((product) => this.transformGraphqlProduct(product));

    return products;
  },

  async getShopifyArticleList(tags) {
    const tagQuery = tags.map((tag) => `tag:'${tag}'`).join(' OR ');
    const data = `{
        articles(first: 10, query: "(${tagQuery})") {
            edges {
                node {
                    id
                    title
                    tags
                    excerpt
                    publishedAt
                    handle
                    blog {
                        handle
                    }
                    image {
                        src
                        altText
                    }
                }
            }
        }
    }`;

    let headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
    };
    
    const endpoint = api.getStorefrontGraphqlBaseUrl();
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: data
    });

    const jsonResponse = await response.json();
    const articles = jsonResponse.data?.articles.edges.map((edge) => edge.node);

    console.log(articles);

    const transformedArticles = articles.map((article) => this.transformGraphqlArticle(article));

    return transformedArticles;
  },

  transformGraphqlArticle(article) {
    return {
      id: article.id,
      title: article.title,
      url: article.url,
      handle: article.handle,
      tags: article.tags,
      excerpt: article.excerpt,
      publishedAt: article.publishedAt,
      blog: article.blog
        ? {
            handle: article.blog.handle
          }
        : null,
      image: article.image
        ? {
            src: article.image.src,
            altText: article.image.altText
          }
        : null
    };
  },

  async getShopifyProductList(productData) {
    // Get metafield identifiers from window object
    const metafieldIdentifiers = window.productMetafieldIdentifiers || [];

    const data = {
      query: GET_PRODUCTS_QUERY.loc.source.body,
      variables: {
        ids: productData.reduce((filtered, id) => {
          filtered.push('gid://shopify/Product/' + id);
          return filtered;
        }, []),
        metafieldIdentifiers: metafieldIdentifiers
      }
    };

    let headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
    };

    const endpoint = api.getStorefrontGraphqlBaseUrl();
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    });

    const jsonResponse = await response.json();

    const products = jsonResponse.data?.nodes
      .filter((node) => node)
      .map((product) => this.transformGraphqlProduct(product));

    return products;
  },

  async getRelatedProducts(products, checkTag = 'colour:') {
    const tags = products.flatMap((product) => product.tags.filter((tag) => tag.startsWith(checkTag)));
    const uniqueTags = [...new Set(tags)];
    const relatedProductsQuery = this.getRelatedProductsQuery(uniqueTags);

    let headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
    };

    const endpoint = api.getStorefrontGraphqlBaseUrl();
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: relatedProductsQuery
    });

    const jsonResponse = await response.json();

    const relatedProducts = jsonResponse.data?.products?.edges.map((edge) => edge.node);
    return relatedProducts || [];
  },

  async getProductsByHandle(product_handles) {
    // Extract handles from tags that start with the given prefix
    if (product_handles.length > 0) {
      const relatedProductsQuery = this.getRelatedProductsByHandleQuery(product_handles);

      // console.log('Handle Products', relatedProductsQuery);

      let headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
      };

      const endpoint = api.getStorefrontGraphqlBaseUrl();
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: relatedProductsQuery
      });

      const jsonResponse = await response.json();

      const relatedProducts = jsonResponse.data?.products?.edges.map((edge) => edge.node);
      const transformedRelatedProducts = relatedProducts?.map((product) => this.transformGraphqlProduct(product));
      return transformedRelatedProducts || [];
    }
    return [];
  },

    /**
     * Fetch products for a given collection handle using Storefront API
     * @param {string} collectionHandle - The handle of the collection
     * @returns {Promise<Array>} Array of product objects
     */
    async getProductsForCollection(collectionHandle, limit = 10) {
      if (!collectionHandle) return [];
      const query = `
        query getProductsForCollection($handle: String!, $limit: Int!) {
          collectionByHandle(handle: $handle) {
            products(first: $limit) {
              edges {
                node {
                  ...ProductFragment
                }
              }
            }
          }
        }
        ${PRODUCT_FRAGMENT.loc.source.body}
      `;
      const variables = {
        handle: collectionHandle,
        limit
      };
      const headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
      };
      const endpoint = api.getStorefrontGraphqlBaseUrl();
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers,
          body: JSON.stringify({ query, variables })
        });
        const json = await response.json();
        const edges = json?.data?.collectionByHandle?.products?.edges || [];
        return edges.map(edge => this.transformGraphqlProduct(edge.node));
      } catch (error) {
        console.error('Error fetching products for collection:', error);
        return [];
      }
    },
  async getProductByHandle(product_handle) {
    // Fetch a single product by handle
    if (product_handle) {
      const singleProductQuery = this.getSingleProductByHandleQuery(product_handle);

      let headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
      };

      const endpoint = api.getStorefrontGraphqlBaseUrl();
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: singleProductQuery })
      });

      const jsonResponse = await response.json();

      const product = jsonResponse.data?.product;
      const transformedProduct = product ? this.transformGraphqlProduct(product) : null;
      
      return transformedProduct;
    }
    return null;
  },

  /**
   * Fetch interactive features slides for a product using Storefront API
   * @param {string} productId - The ID or handle of the product
   * @returns {Promise<Array>} Array of interactive feature slide objects
   */
  async getInteractiveFeaturesSlides(productId) {
    const productGid = productId.startsWith('gid://shopify/Product/') ? productId : `gid://shopify/Product/${productId}`;
    const query = `
      query getInteractiveFeaturesSlides($id: ID!) {
        product(id: $id) {
          id
          handle
          interactiveFeatures: metafield(namespace: "custom", key: "interactive_features_slides") {
            value
            references(first: 10) {
              nodes {
                ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                    key
                    value
                    reference {
                      ... on MediaImage {
                        id
                        image {
                          url
                          altText
                          width
                          height
                        }
                      }
                    }
                    references(first: 20) {
                      nodes {
                        ... on Metaobject {
                          id
                          handle
                          type
                          fields {
                            key
                            value
                            reference {
                              ... on MediaImage {
                                id
                                image {
                                  url
                                  altText
                                  width
                                  height
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = { id: productGid };

    const headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
    };
    const endpoint = api.getStorefrontGraphqlBaseUrl();
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ query, variables })
    });

    const jsonResponse = await response.json();
    // console.debug('Interactive Features API Response:', jsonResponse);
    
    if (!jsonResponse?.data?.product?.interactiveFeatures?.references?.nodes) {
      return [];
    }

    return this.transformInteractiveFeaturesSlides(jsonResponse.data.product.interactiveFeatures.references.nodes);
  },

  /**
   * Transform GraphQL interactive features slides data into component-friendly format
   * @param {Array} slidesNodes - Raw GraphQL nodes
   * @returns {Array} Transformed slides data
   */
  transformInteractiveFeaturesSlides(slidesNodes) {
    return slidesNodes.map(slide => {
      // console.debug('Processing slide:', slide);
      
      // Process each field to build a structured object
      let slideData = {
        id: slide.id,
        title: '',
        slide_name: '',
        image: { url: '', alt: '' },
        feature_items: []
      };

      slide.fields.forEach(field => {
        // console.debug('Processing field:', field.key, field);
        switch (field.key) {
          case 'title':
            slideData.title = field.value || '';
            break;
          case 'slide_name':
            slideData.slide_name = field.value || '';
            break;
          case 'image':
            if (field.reference?.image) {
              slideData.image = {
                url: field.reference.image.url,
                alt: field.reference.image.altText || '',
                width: field.reference.image.width || null,
                height: field.reference.image.height || null
              };
            }
            break;
          case 'feature_items':
            if (field.references?.nodes) {
              slideData.feature_items = field.references.nodes.map(item => {
                // console.debug('Processing feature item:', item);
                let itemData = {
                  id: item.id,
                  title: '',
                  display_name: '',
                  description: '',
                  image: { url: '', alt: '' },
                  left: 0,
                  top: 0
                };

                item.fields.forEach(itemField => {
                  switch (itemField.key) {
                    case 'title':
                      itemData.title = itemField.value || '';
                      break;
                    case 'display_name':
                      itemData.display_name = itemField.value || '';
                      break;
                    case 'description':
                      let description = itemField.value || '';
                      try {
                        if (description.startsWith('{') && description.includes('"type":"root"')) {
                          const richTextObj = JSON.parse(description);
                          description = this.extractTextFromRichText(richTextObj);
                        }
                      } catch (e) {
                        console.warn('Failed to parse rich text description:', e);
                      }
                      itemData.description = description;
                      break;
                    case 'image':
                      if (itemField.reference?.image) {
                        itemData.image = {
                          url: itemField.reference.image.url,
                          alt: itemField.reference.image.altText || '',
                          width: itemField.reference.image.width || null,
                          height: itemField.reference.image.height || null
                        };
                      }
                      break;
                    case 'left':
                      itemData.left = parseFloat(itemField.value) || 0;
                      break;
                    case 'top':
                      itemData.top = parseFloat(itemField.value) || 0;
                      break;
                  }
                });

                return itemData;
              });
            }
            break;
        }
      });

      // console.debug('Transformed slide data:', slideData);
      return slideData;
    });
  },

  /**
   * Extract plain text from Shopify rich text JSON structure
   * @param {Object} richTextObj - Rich text JSON object
   * @returns {string} Plain text content
   */
  extractTextFromRichText(richTextObj) {
    if (!richTextObj || !richTextObj.children) {
      return '';
    }

    let text = '';
    
    const processNode = (node) => {
      if (node.type === 'text') {
        text += node.value;
      } else if (node.children) {
        node.children.forEach(processNode);
      }
    };

    richTextObj.children.forEach(processNode);
    return text;
  },

  async getRelatedProductsByTag(product, tagPrefix = 'colour:') {
    // Extract handles from tags that start with the given prefix
    const tags = product.tags
      .filter((tag) => tag.startsWith(tagPrefix))
      .map((tag) => tag.replace(tagPrefix, '').trim());

    const uniqueTags = [...new Set(tags)]; // Get unique handles

    if (uniqueTags.length > 0) {
      const relatedProductsQuery = this.getRelatedProductsByHandleQuery(uniqueTags);

      let headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
      };

      const endpoint = api.getStorefrontGraphqlBaseUrl();
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: relatedProductsQuery
      });

      const jsonResponse = await response.json();

      const relatedProducts = jsonResponse.data?.products?.edges.map((edge) => edge.node);
      const transformedRelatedProducts = relatedProducts?.map((product) => this.transformGraphqlProduct(product));
      return transformedRelatedProducts || [];
    }
    return [];
  },

  async getRecommendedProducts(productId) {
    try {
      let headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': `${api.getStorefrontToken()}`
      };

      const response = await fetch(`${helpers.getDomain()}/recommendations/products.json?product_id=${productId}`, {
        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        throw new Error(`Error fetching recommendations: ${response.statusText}`);
      }

      const jsonResponse = await response.json();

      // console.log("Recommended response:", jsonResponse);
      return jsonResponse.products || [];
    } catch (error) {
      console.error('Failed to fetch product recommendations:', error);
    }
  },

  transformPrice(price) {
    return price / 100;
  },

  transformGraphqlProduct(productNode, collectionHandle = null) {
    const hasOnlyDefaultVariant = (productNode?.options?.[0]?.values?.[0] ?? '') === 'Default Title';

    return productNode
      ? {
          ...productNode,
          objectType: 'product',
          url: collectionHandle
            ? `/collections/${collectionHandle}/products/${productNode.handle}`
            : `/products/${productNode.handle}`,
          id: parseInt(productNode.id.replace('gid://shopify/Product/', '')),
          tags: productNode.tags?.map((tag) => tag),
          // collections data for category extraction
          collections:
            productNode.collections?.edges.map(({ node }) => ({
              id: parseInt(node.id.replace('gid://shopify/Collection/', '')),
              title: node.title,
              handle: node.handle
            })) || [],
          // metafield values are transformed into arrays for consistency
          metafields: productNode.metafields
            ?.filter((node) => node)
            .map((metafield) => {
              return {
                ...metafield,
                value: metafield.value.includes('[') ? JSON.parse(metafield.value).flat() : [metafield.value]
              };
            }),
          variants: productNode.variants?.edges.map(({ node }) => {
            return {
              id: parseInt(node.id.replace('gid://shopify/ProductVariant/', '')),
              available: node.availableForSale,
              sku: node.sku,
              compare_at_price: node.compareAtPrice?.amount * 100 || null,
              options: node.selectedOptions.map((option) => option.value),
              image: {
                alt: node?.image?.altText ? node.image.altText : productNode.title,
                media_type: 'image',
                src: node?.image?.url ? node.image.url : null
              }
            };
          }),
          selling_plan_groups: productNode.sellingPlanGroups?.edges.map(({ node }) => {
            return {
              name: node.name,
              options: node.options.map((option) => option),
              selling_plans: node.sellingPlans.edges.map(({ node }) => {
                return {
                  id: parseInt(node.id.replace('gid://shopify/SellingPlan/', '')),
                  name: node.name,
                  description: node.description,
                  price_adjustments: node.priceAdjustments.map(({ adjustmentValue }) => {
                    return {
                      value_type: 'percentage',
                      value: adjustmentValue.adjustmentPercentage
                    };
                  })
                };
              })
            };
          }),
          price_calculated: productNode.priceRange?.minVariantPrice.amount,
          compare_at_price_calculated: productNode.variants?.edges[0].node.compareAtPrice?.amount || null,
          price: productNode.priceRange?.minVariantPrice.amount * 100,
          compare_at_price: productNode.variants?.edges[0].node.compareAtPrice?.amount * 100 || null,
          featuredImage: {
            alt: productNode?.featuredImage?.altText ? productNode.featuredImage.altText : productNode.title,
            media_type: 'image',
            src: productNode?.featuredImage?.url ? productNode.featuredImage.url : null
          },
          media: productNode.images?.edges.map((image) => {
            return {
              alt: image?.node?.altText ? image.node.altText : productNode.title,
              media_type: 'image',
              src: image?.node?.url ? image.node.url : null
            };
          }),
          has_only_default_variant: hasOnlyDefaultVariant,
          options: productNode.options?.map((option) => option.name),
          options_with_values: productNode.options?.map((option) => {
            return {
              name: option.name,
              position: productNode.options.indexOf(option) + 1,
              values: option.values
            };
          })
        }
      : null;
  },

  getShopifyImageUrl(originalUrl, width = null, height = null, customQueries = null) {
    const params = {
      width: width ? Math.ceil(width) : null,
      height: height ? Math.ceil(height) : null,
      ...customQueries
    };

    const url = helpers.updateUrlParameters(originalUrl, params);
    return url;
  },

  // Convert Shopify richtext schema into HTML
  // Refer to https://github.com/TheBeyondGroup/shopify-rich-text-renderer#readme for more details
  renderRichText(schema, options) {
    return convertSchemaToHtml(schema, options);
  },

  // Decoding escaped string - Use for escaped HTML (ex. collection description)
  decodeLiquidEscape(input) {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent || '';
  },

  // Decoding and parsing escaped JSON string - Use for escaped object (ex. richtext)
  decodeAndParseLiquidEscapeObject(input) {
    return JSON.parse(this.decodeLiquidEscape(input));
  },

  getVideoSrc(video) {
    return video?.sources.find((source) => source.format === 'mp4');
  },

  interpolateLocale(str, data) {
    let result = str;
    const variables = Object.keys(data);
    variables.forEach((variable) => {
      result = result.replace(`{{ ${variable} }}`, data[variable]);
    });

    return result;
  },

  getShopifyFileUrl(handle, fileType) {
    return window.fileUrl.split('?')[0].replace('replace', `${handle}.${fileType}`);
  },

  async getCountries() {
    const data = await addressFormatter.getCountries();

    return data;
  },

  async getProvinces(countryCode) {
    const data = await addressFormatter.getCountry(countryCode);

    return data.zones;
  },

  async getCollectionsByHandles(collectionHandles) {
    if (collectionHandles.length === 0) return [];

    const query = `{
      ${collectionHandles.map(handle => `
        ${handle.replaceAll('-', '_')}: collectionByHandle(handle: "${handle}") {
          title
          handle
          metafield (namespace: "custom", key: "header_search_image") {
            reference {
              ... on MediaImage {
                image {
                  src
                  altText
                  width
                  height
                }
              }
            }
          }
          image {
            src
            altText
            width
            height
          }
        }
      `).join('')}
    }`;
    // console.log('getCollectionsByHandles query', query);

    let headers = {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
    };

    const endpoint = api.getStorefrontGraphqlBaseUrl();
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: query
    });

    const jsonResponse = await response.json();
    // console.log('response', jsonResponse);

    return jsonResponse.data ? Object.values(jsonResponse.data) : [];
  }
};
